/**
 * Encoding utilities — thin wrappers around the platform's TextEncoder/
 * TextDecoder and base64url, kept centrally so every module uses the same
 * implementation and we avoid subtle inconsistencies.
 */

const encoder = new TextEncoder();
const decoder = new TextDecoder();

export const encodeUtf8 = (s: string): Uint8Array => encoder.encode(s);
export const decodeUtf8 = (b: Uint8Array): string => decoder.decode(b);

export function base64UrlEncode(bytes: Uint8Array): string {
  let binary = '';
  for (const b of bytes) binary += String.fromCharCode(b);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

export function base64UrlDecode(s: string): Uint8Array {
  const padded = s.replace(/-/g, '+').replace(/_/g, '/');
  const pad = (4 - (padded.length % 4)) % 4;
  const binary = atob(padded + '='.repeat(pad));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

/** Parse the unverified header of a compact JWS/JWE without signature checks. */
export function peekProtectedHeader(compact: string): Record<string, unknown> {
  const headerB64 = compact.split('.')[0];
  if (!headerB64) throw new Error('Malformed compact serialisation.');
  return JSON.parse(decodeUtf8(base64UrlDecode(headerB64)));
}
